
namespace GeniuzPOS.Member {
    import fld = ReportMemberConditionRow.Fields;
    @Serenity.Decorators.registerClass()
    export class ReportMemberConditionGrid extends Serenity.EntityGrid<ReportMemberConditionRow, any> {
        protected getColumnsKey() { return ReportMemberConditionColumns.columnsKey; }
        protected getDialogType() { return ReportMemberConditionDialog; }
        protected getIdProperty() { return ReportMemberConditionRow.idProperty; }
        protected getInsertPermission() { return ReportMemberConditionRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportMemberConditionRow.localTextPrefix; }
        protected getService() { return ReportMemberConditionService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            // new Serenity.AutoColumnWidthMixin({
            //     grid: this
            // });

            return this.slickGrid;
        }
        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
            let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            let columns = Object.keys(options.columnStyles)

            let descriptions: string[] = [];

            if (request?.Criteria) {
                let criteria = request.Criteria.toString().split(',');
                let key: string = criteria[0];

                let n = columns.find(n => {
                    return options.columnStyles[n]['field'] === key
                });
                if (n) {
                    key = options.columnStyles[n]['title'];
                }

                let d1 = criteria.findIndex(c => c == ">=");
                if (d1 >= 0) {
                    let v1 = criteria[d1 + 1];
                    let d2 = criteria.findIndex(c => c == "<");

                    if (d2 >= 0) {
                        let v2 = criteria[d2 + 1];

                        descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy" + ' (00:00)')}  -  ${Q.formatDate(v2, "dd/MM/yyyy" + ' (00:00)')}`);

                    } else {
                        descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy")}`);
                    }
                } else {
                    let d2 = criteria.findIndex(c => c == "<");
                    if (d2 >= 0) {
                        let v2 = criteria[d2 + 1];
                        descriptions.push(`${key} ถึง  ${Q.formatDate(v2, "dd/MM/yyyy")}`);
                    }
                }
            } else {
                descriptions.push("วันที่ = ไม่ระบุ");
            }



            console.log(request)
            if (request?.EqualityFilter) {
                let quickFilters = this.getQuickFilters();

                let filters = Object.keys(request.EqualityFilter);

                for (let filterCol of filters) {
                    let quickFilter = Q.first(quickFilters, x => x.field === filterCol);
                    let filterValue = request.EqualityFilter[filterCol];
                    // if else{
                    if (filterValue.length > 0) {
                        if (Array.isArray(filterValue)) {
                            if (quickFilter.options.lookupKey) {
                                // console.log(filterValue);
                                (filterValue as any[]).forEach(value => {
                                    var names: string[] = new Array(filterValue);
                                    for (var i = 0; i < names.length; i++) {
                                        filterValue = (names[i]);
                                        console.log(filterValue);
                                    }
                                })

                            }
                        } else {
                            filterValue
                        }
                    }
                    else {
                        filterValue = "ไม่ระบุ"
                    }
                    // }

                    let n = columns.find(n => {
                        return options.columnStyles[n]['field'] === filterCol
                    });
                    if (n) {  
                        if (filterValue != "ไม่ระบุ") {                                              
                                descriptions.push(`${options.columnStyles[n]['title']} = ${filterValue}`)
                            }
                        } else {                   
                        }
                }
            }
            return [descriptions, gridColumns];
        }
        // protected createQuickSearchInput() {
        // }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }
        // protected getViewOptions() {
        //     var opt = super.getViewOptions();
        //     opt.localSort = true;
        //     return opt;
        // }


        protected usePager() {
            return false;
        }


        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["MbType"]);
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }
        protected markupReady() {
            super.markupReady();
    
            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);
        }



        protected getButtons() {
            var buttons = super.getButtons();
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)
            buttons.filter(x => x.cssClass = "refresh-button")
            // Add buttons export excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: ReportMemberConditionService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            


            let reportTitle = 'รายงานทะเบียนสมาชิก(Member list)'

            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "MbType", title: "ประเภท", cellWidth: 5, halign: 'center' },
                1: { field: "MbId", title: "รหัสสมาชิก", cellWidth: 30 },
                
                2: { field: "MbNameT", title: "ชื่อสมาชิก", cellWidth: 30, overflow: 'linebreak' },
                3: { field: "MbNameE", title: "์Name", cellWidth: 30 },
                4: { field: "MbPid", title: "รหัสบัตรประชาชน", cellWidth: 25 },


                5: { field: "MbBirthDay", title: "วันเกิด", cellWidth: 20, halign: 'center' },
                6: { field: "MbApplyDate", title: "วันที่สมัคร", cellWidth: 20, halign: 'center' },

                7: { field: "MbAccumPoint", title: "แต้มสะสม", cellWidth: 15, halign: 'right' },
                8: { field: "MbNearlyExpirePoint", title: "แต้มสะสมที่กำลังจะหมดอายุ", cellWidth: 20, halign: 'right' },
                9: { field: "MbExpirePointDate", title: "วันที่แต้มหมดอายุ", cellWidth: 20, halign: 'center' },
                10: { field: "MbExpireDate", title: "วันบัตรหมดอายุ", cellWidth: 20, halign: 'center' },

                11: { field: "MbAddress", title: "ที่อยู่", cellWidth: 35, overflow: 'linebreak' },
                12: { field: "MbTumbol", title: "ตำบลแขวง", cellWidth: 20, overflow: 'linebreak' },
                13: { field: "MbAmphur", title: "อำเภอ/เขต", cellWidth: 20, overflow: 'linebreak' },
                14: { field: "MbProvince", title: "จังหวัด", cellWidth: 20, overflow: 'linebreak' },
                15: { field: "MbZipCode", title: "ไปรษณีย์", cellWidth: 10, halign: 'center', overflow: 'linebreak' },
                16: { field: "MbTelNo", title: "เบอร์", cellWidth: 20, overflow: 'linebreak' },
                17: { field: "MbEmail", title: "Email", cellWidth: 20, overflow: 'linebreak' },

                18: { field: "MbMemo", title: "Memo", cellWidth: 40, overflow: 'linebreak' },

                
                // 21: { field: "MbGender", title: "เพศ", cellWidth: 9, halign: 'center' },
                19: { field: "MbNation", title: "สัญชาติ", cellWidth: 10, halign: 'center', overflow: 'linebreak' },
                20: { field: "MbRace", title: "เชื้อชาติ", cellWidth: 10, halign: 'center', overflow: 'linebreak' },
                21: { field: "MbOccupation", title: "อาชีพ", cellWidth: 20, overflow: 'linebreak' },
                22: { field: "MbType", title: "ประเภทสมาชิก", isHidden:true },
                23: { field: "MbGender", title: "ประเภทสมาชิก", isHidden:true },
                24: { field: "CreateBy", title: "สร้างโดย", isHidden:true },
                25: { field: "LastUpdate", title: "วันที่แก้ล่าสุด", isHidden:true },
                26: { field: "UpdateBy", title: "แก้ไขโดย", isHidden:true },
                27: { field: "MbCardStatus", title: "สถานะบัตร", cellWidth: 10, halign: 'center' },
                28: { field: "MbCardType", title: "ประเภทบัตร", isHidden:true },

            }
            // buttons.push(GeniuzPOS.Common.Helpers.MbReportPdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            // buttons.push(GeniuzPOS.Common.Helpers.MbReportPdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     //separator: true,
               
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            return buttons;
        }

        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

            // get quick filter list from base class, e.g. columns
            let filters = super.getQuickFilters();
            let accPoint: Serenity.DecimalEditor = null;

            filters.push({
                field: fld.MbAccumPoint,
                type: Serenity.DecimalEditor,
                title: 'แต้งสะสมระหว่าง',
                element: e1 => {
                    e1.css("width", "80px");
                    accPoint = Serenity.Widget.create({
                        type: Serenity.DecimalEditor,
                        element: e2 => e2.insertAfter(e1).css("width", "80px")
                    });

                    accPoint.element.change(x => e1.triggerHandler("change"));
                    $("<span/>").addClass("range-separator").text("-").insertAfter(e1);
                },
                handler: h => {
                    var active1 = h.value != null && !isNaN(h.value);
                    var active2 = accPoint.value != null && !isNaN(accPoint.value);
                    h.active = active1 || active2;

                    if (active1)
                        h.request.Criteria = Serenity.Criteria.and(h.request.Criteria,
                            [[fld.MbAccumPoint], '>=', h.value]);

                    if (active2)
                        h.request.Criteria = Serenity.Criteria.and(h.request.Criteria,
                            [[fld.MbAccumPoint], '<=', accPoint.value]);
                }

            });

            return filters;
        }

    }
}